import { Pipe, PipeTransform, inject } from '@angular/core';
import { I18nService } from '../../core/i18n';

@Pipe({
  name: 't',
  standalone: true,
  pure: false,
})
export class TPipe implements PipeTransform {
  private readonly i18n = inject(I18nService);

  transform(
    key: string | null | undefined,
    params?: Record<string, string | number>,
    fallback?: string
  ): string {
    void this.i18n.locale();
    if (!key) return '';
    return this.i18n.t(key, params, fallback);
  }
}
